import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LoaderComponent } from './components/loader/loader.component'
import { TrimInputDirective } from '../directives/trim-input.directive'

@NgModule({
  declarations: [],
  imports: [CommonModule, LoaderComponent, TrimInputDirective],
  exports: [LoaderComponent, TrimInputDirective]
})
export class SharedModule {}
